export default function TextEditor({ text, onChange }) {
  return (
    <textarea
      className="text-editor"
      value={text}
      onChange={(e) => onChange(e.target.value)}
      spellCheck={false}
    />
  );
}
